/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Cardano API
 * RESTful API for Cardano
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ArbitragesResponse,
  GetArbitragesParams,
  TransactionHistoryResponse
} from '../model';

import { arbBotFetcher } from '../../../lib/api/fetcher.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetArbitragesUrl = (params?: GetArbitragesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/arbitrages?${stringifiedParams}` : `/api/arbitrages`
}

export const getArbitrages = async (params?: GetArbitragesParams, options?: Parameters<typeof arbBotFetcher>[1]): Promise<ArbitragesResponse> => {

  return arbBotFetcher<ArbitragesResponse>(getGetArbitragesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetArbitragesQueryKey = (params?: GetArbitragesParams,) => {
    return [
    `/api/arbitrages`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetArbitragesQueryOptions = <TData = Awaited<ReturnType<typeof getArbitrages>>, TError = void>(params?: GetArbitragesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArbitrages>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetArbitragesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getArbitrages>>> = ({ signal }) => getArbitrages(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getArbitrages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetArbitragesQueryResult = NonNullable<Awaited<ReturnType<typeof getArbitrages>>>
export type GetArbitragesQueryError = void


export function useGetArbitrages<TData = Awaited<ReturnType<typeof getArbitrages>>, TError = void>(
 params: undefined |  GetArbitragesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArbitrages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArbitrages>>,
          TError,
          Awaited<ReturnType<typeof getArbitrages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArbitrages<TData = Awaited<ReturnType<typeof getArbitrages>>, TError = void>(
 params?: GetArbitragesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArbitrages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArbitrages>>,
          TError,
          Awaited<ReturnType<typeof getArbitrages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArbitrages<TData = Awaited<ReturnType<typeof getArbitrages>>, TError = void>(
 params?: GetArbitragesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArbitrages>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetArbitrages<TData = Awaited<ReturnType<typeof getArbitrages>>, TError = void>(
 params?: GetArbitragesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArbitrages>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetArbitragesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetExecuteTradeUrl = () => {




  return `/api/arbitrages/get-execute-trade`
}

export const getExecuteTrade = async ( options?: Parameters<typeof arbBotFetcher>[1]): Promise<boolean> => {

  return arbBotFetcher<boolean>(getGetExecuteTradeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetExecuteTradeQueryKey = () => {
    return [
    `/api/arbitrages/get-execute-trade`
    ] as const;
    }


export const getGetExecuteTradeQueryOptions = <TData = Awaited<ReturnType<typeof getExecuteTrade>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecuteTrade>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExecuteTradeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExecuteTrade>>> = ({ signal }) => getExecuteTrade({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExecuteTrade>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExecuteTradeQueryResult = NonNullable<Awaited<ReturnType<typeof getExecuteTrade>>>
export type GetExecuteTradeQueryError = unknown


export function useGetExecuteTrade<TData = Awaited<ReturnType<typeof getExecuteTrade>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecuteTrade>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExecuteTrade>>,
          TError,
          Awaited<ReturnType<typeof getExecuteTrade>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExecuteTrade<TData = Awaited<ReturnType<typeof getExecuteTrade>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecuteTrade>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExecuteTrade>>,
          TError,
          Awaited<ReturnType<typeof getExecuteTrade>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExecuteTrade<TData = Awaited<ReturnType<typeof getExecuteTrade>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecuteTrade>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetExecuteTrade<TData = Awaited<ReturnType<typeof getExecuteTrade>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecuteTrade>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExecuteTradeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetArbitragesHistoryUrl = () => {




  return `/api/arbitrages/history`
}

export const getArbitragesHistory = async ( options?: Parameters<typeof arbBotFetcher>[1]): Promise<TransactionHistoryResponse> => {

  return arbBotFetcher<TransactionHistoryResponse>(getGetArbitragesHistoryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetArbitragesHistoryQueryKey = () => {
    return [
    `/api/arbitrages/history`
    ] as const;
    }


export const getGetArbitragesHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getArbitragesHistory>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArbitragesHistory>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetArbitragesHistoryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getArbitragesHistory>>> = ({ signal }) => getArbitragesHistory({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getArbitragesHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetArbitragesHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getArbitragesHistory>>>
export type GetArbitragesHistoryQueryError = unknown


export function useGetArbitragesHistory<TData = Awaited<ReturnType<typeof getArbitragesHistory>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArbitragesHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArbitragesHistory>>,
          TError,
          Awaited<ReturnType<typeof getArbitragesHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArbitragesHistory<TData = Awaited<ReturnType<typeof getArbitragesHistory>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArbitragesHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArbitragesHistory>>,
          TError,
          Awaited<ReturnType<typeof getArbitragesHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArbitragesHistory<TData = Awaited<ReturnType<typeof getArbitragesHistory>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArbitragesHistory>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetArbitragesHistory<TData = Awaited<ReturnType<typeof getArbitragesHistory>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArbitragesHistory>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetArbitragesHistoryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






